import { combineReducers } from 'redux';

import checkboxFields from './checkboxFields';
import signatureFields from './signatureFields';
import textFields from './textFields';

export default combineReducers({
  checkboxFields,
  signatureFields,
  textFields,
});
